import React, { FC } from 'react';
import {
  Button,
  createStyles,
  Grid,
  makeStyles,
  Theme,
} from '@material-ui/core';
import DetailItem from '../DetailItem/DetailItem';
import DetailItemArray from '../DetailItem/DetailItemArray';
import CustomAccordion from '../../../../common/components/CustomAccordion/CustomAccordion';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    center: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
);

interface Params {
  setIsEditingEntities(isEditing: boolean): void;
  enseigneName: string;
  entitiesName: (string | null)[];

  canEditUser: boolean;
}

const UserRattachement: FC<Params> = (props) => {
  const {
    setIsEditingEntities,
    enseigneName,
    entitiesName,
    canEditUser,
  } = props;
  const classes = useStyles();

  const handleClickEdit = () => {
    setIsEditingEntities(true);
  };

  return (
    <CustomAccordion title="Rattachement">
      <Grid container>
        <DetailItem name="Enseigne" value={enseigneName || 'Aucune enseigne'} />
        <DetailItemArray values={entitiesName} name="Entité(s)" />
        {canEditUser && (
          <Grid item xs={12} className={classes.center}>
            <Button
              onClick={handleClickEdit}
              color="secondary"
              variant="outlined">
              {entitiesName.length
                ? 'Rattacher a une autre entite'
                : 'Rattacher a une entite'}
            </Button>
          </Grid>
        )}
      </Grid>
    </CustomAccordion>
  );
};

export default UserRattachement;
